"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROUTING_ENGINE = void 0;
const ManualRoutingService_1 = __importDefault(require("./ManualRoutingService"));
const OSRMRoutingService_1 = __importDefault(require("./OSRMRoutingService"));
exports.DEFAULT_ROUTING_ENGINE = 'engine';
/**
 * This class manages the various routing services and engines for the application
 */
class RoutingServiceManagerImpl {
    constructor() {
        this.getRoutingServiceForEngine = (engine) => {
            const service = engine ? this._routingServices[engine] : undefined;
            return service ? service : this._defaultService;
        };
        // FIXME Do not configure in this class, as some apps could add engines,
        // use different services for same engine, etc
        this._defaultService = new ManualRoutingService_1.default();
        const osrmService = new OSRMRoutingService_1.default();
        this._routingServices = {
            manual: this._defaultService,
            engine: osrmService,
            engineCustom: osrmService
        };
    }
}
const routingServiceManager = new RoutingServiceManagerImpl();
exports.default = routingServiceManager;
//# sourceMappingURL=RoutingServiceManager.js.map